module.exports = __webpack_public_path__ + "static/lageplan_auto-c798d88a3c879d0f86c64af4fc25ce0b.png";